





































import { Component, Prop, Vue } from 'vue-property-decorator';
import Menu from '@/components/menu/Menu.vue';
import LocalePicker from '@/components/menu/LocalePicker.vue';

@Component({
  components: {
    Menu,
    LocalePicker
  }
})
export default class AppNav extends Vue {}
